// src/redux/actions/timeActions.js

export const SET_HOVERED_TIME = "SET_HOVERED_TIME";

export const setHoveredTime = (time) => ({
  type: SET_HOVERED_TIME,
  payload: time,
});
